import { useEffect, useCallback } from 'react';
import { useUser } from '../../../hooks/useUser';
import { usePaymentStore } from '../../../config/advertiser.stores';
import paymentService from '../../../services/payment.service';

import 'react-credit-cards-2/dist/es/styles-compiled.css';
import './index.css';
import Cards from "react-credit-cards-2";

export const PaymentMethodPreview = () => {
    const user = useUser();

    const paymentMethod = usePaymentStore((state) => state.paymentMethod);
    const setPaymentMethod = usePaymentStore((state) => state.setPaymentMethod);

    const fetchData = useCallback(async () => {
        const methodResponse = await paymentService.getCard(user.id);
        setPaymentMethod(methodResponse);
    }, [user.id, setPaymentMethod]);

    useEffect(() => {
        if (paymentMethod === null) {
            fetchData();
        }
        // eslint-disable-next-line
    }, []);

    return (
        <>
            { paymentMethod !== null ? (
                <Cards
                    number={`**** **** **** ${paymentMethod.last4}`}
                    expiry={paymentMethod.getExpiryString()}
                    placeholders={{ name: "" }}
                    preview={true}
                    issuer={paymentMethod.brand}
                    cvc={''}
                    name={''}
                />
            ) : (
                <PaymentMethodPlaceholder />
            )}
        </>
    )
}

export const PaymentMethodPlaceholder = () => {
    return (
        <Cards
            number=""
            placeholders={{ name: "" }}
            preview={true}
            cvc={''}
            name={''}
            expiry={''}
        />
    )
}
